// extracted by mini-css-extract-plugin
module.exports = {"Loading":"loading_Loading__nqZOu","Loader":"loading_Loader__JJ4NR","spin":"loading_spin__JnJIH"};